import store from '@/store'

async function waitForRedirect() {
  return new Promise(() => {});
}

/**
 * 同心頁面：要求用戶已完成 WIP 系統綁定（registered_at 有值）
 * from=web 的 guest 流程不受此限制
 */
export default async function tongxinRequireRegistered({ next, to }) {
  if (store.getters['web/tongxin/isGuest']) {
    return next();
  }

  if (!store.state.liffAuth.user?.registered_at) {
    // 轉跳前，將 clinicCode、sourceType 存入 localStorage（保留 30 分鐘）
    const currentUrl = new URL(window.location.href);
    const clinicCode = currentUrl.searchParams.get('clinicCode') || to.query.clinicCode;
    const sourceType = currentUrl.searchParams.get('sourceType') || to.query.sourceType;
    if (clinicCode || sourceType) {
      const data = {
        clinicCode: clinicCode || null,
        sourceType: sourceType || null,
        expiresAt: Date.now() + 30 * 60 * 1000,
      };
      localStorage.setItem('tongxin_redirect_params', JSON.stringify(data));
    }

    const orgCode = store.state.liffGeneral.orgCode;
    const redirectUri = encodeURIComponent(window.location.origin + window.location.pathname + window.location.search);
    const registerUrl = `${window.location.origin}/${orgCode}/liff/register?redirect_uri=${redirectUri}`;
    window.location.href = registerUrl;
    await waitForRedirect();
  }

  return next();
}
